import { Navigate, Route, Routes } from 'react-router-dom';
import { useMe } from './api/queries';
import { Shell } from './components/app/Shell';
import { Skeleton } from './components/kit/Note';
import { LoginPage } from './features/auth/LoginPage';
import { ResetPasswordPage } from './features/auth/ResetPasswordPage';
import { ClientPage } from './features/base/clients/ClientPage';
import { ClientsListPage } from './features/base/clients/ClientsListPage';
import { NewClientPage } from './features/base/clients/NewClientPage';
import { StudioPage } from './features/base/studios/StudioPage';
import { StudiosListPage } from './features/base/studios/StudiosListPage';
import { TeamPage } from './features/base/teams/TeamPage';
import { TeamsListPage } from './features/base/teams/TeamsListPage';
import { CrmSettingsPage } from './features/crm/CrmSettingsPage';
import { DealPage } from './features/crm/deals/DealPage';
import { DealsPage } from './features/crm/deals/DealsPage';
import { LeadPage } from './features/crm/leads/LeadPage';
import { LeadsPage } from './features/crm/leads/LeadsPage';
import { StatesPage } from './features/dev/StatesPage';
import { NewRegistrationPage } from './features/registrations/NewRegistrationPage';
import { RegistrationPage } from './features/registrations/RegistrationPage';
import { RegistrationsPage } from './features/registrations/RegistrationsPage';
import { EventPage } from './features/events/EventPage';
import { EventsListPage } from './features/events/EventsListPage';
import { NewEventPage } from './features/events/NewEventPage';
import { NominationPage } from './features/events/NominationPage';
import { PackagePage } from './features/events/PackagePage';
import { ServicePage } from './features/events/ServicePage';

/**
 * Маршруты.
 *
 * Карточки номинации, услуги и пакета лежат под мероприятием:
 * они всегда открываются из него, а вместе с идентификатором
 * мероприятия в адресе ссылка остаётся рабочей, если её переслать.
 */
export function App() {
  const me = useMe();

  if (me.isLoading) {
    return (
      <div className="ui" style={{ padding: 40 }}>
        <Skeleton width={220} height={24} />
      </div>
    );
  }

  if (!me.data) {
    return (
      <Routes>
        <Route path="/reset" element={<ResetPasswordPage />} />
        <Route path="*" element={<LoginPage />} />
      </Routes>
    );
  }

  return (
    <Shell>
      <Routes>
        <Route path="/" element={<Navigate to="/events" replace />} />
        <Route path="/events" element={<EventsListPage />} />
        <Route path="/events/new" element={<NewEventPage />} />
        <Route path="/events/:eventId/nominations/:nominationId" element={<NominationPage />} />
        <Route path="/events/:eventId/services/:serviceId" element={<ServicePage />} />
        <Route path="/events/:eventId/packages/:packageId" element={<PackagePage />} />
        <Route path="/events/:eventId/:tab" element={<EventPage />} />
        <Route path="/events/:eventId" element={<EventPage />} />
        <Route path="/clients" element={<ClientsListPage />} />
        <Route path="/clients/new" element={<NewClientPage />} />
        <Route path="/clients/:clientId" element={<ClientPage />} />
        <Route path="/studios" element={<StudiosListPage />} />
        <Route path="/studios/:studioId" element={<StudioPage />} />
        <Route path="/teams" element={<TeamsListPage />} />
        <Route path="/teams/:teamId/:tab" element={<TeamPage />} />
        <Route path="/teams/:teamId" element={<TeamPage />} />
        <Route path="/crm" element={<Navigate to="/crm/leads" replace />} />
        <Route path="/crm/leads" element={<LeadsPage />} />
        <Route path="/crm/leads/:leadId" element={<LeadPage />} />
        <Route path="/crm/deals" element={<DealsPage />} />
        <Route path="/crm/deals/:dealId" element={<DealPage />} />
        <Route path="/crm/settings" element={<CrmSettingsPage />} />
        <Route path="/registrations" element={<RegistrationsPage />} />
        <Route path="/registrations/new" element={<NewRegistrationPage />} />
        <Route path="/registrations/:registrationId" element={<RegistrationPage />} />
        <Route path="/states" element={<StatesPage />} />
        <Route path="*" element={<Navigate to="/events" replace />} />
      </Routes>
    </Shell>
  );
}
